'use client';

export const dynamic = 'force-dynamic';

import { CLM } from "@/common/schema/claims";
import { SERVICES } from "@/fe/services";
import { Pill } from "@/ui/controls/buttons";
import { Id } from "@/fx/Id";
import { SYS } from "@/common/schema/system";
import { RLT } from "@/common/schema/role-types";
import assert from "assert";
import { useRunImpersonate } from "./useRunImpersonate";

export function UsersSelector({ rawUsers }: {
  rawUsers:    CLM.RawUser[]
}) {
  const { CTX } = SERVICES();
  const { currentUser } = CTX.useLoggedInContext();
  const runImpersonate  = useRunImpersonate();

  const onSelectRole = (role: RLT.RoleType) => {
    const user = rawUsers.find(u => u.roleType === role.identifier);
    assert(user, `There is no available user for role: ${role.identifier}`);
    runImpersonate(Id.from(BigInt(user.id)) as SYS.UserId);
  }
  const onSelectUser = (user: CLM.RawUser) => {
    runImpersonate(Id.from(BigInt(user.id)) as SYS.UserId);
  }

  const selected     = (roleType: RLT.RoleType) => (currentUser.roleType            === roleType)
  const selectedUser = (user    : CLM.RawUser)  => (currentUser.id.asInt.toString() === user.id)

  const hudReady = SYS.testDataCollections.filter(tdc => tdc.data.prefix > 20);

  return <>
    <div className="flex-none rounded-md text-sm font-medium pb-2">
      Roles
      <div className="flex flex-wrap rounded-md text-lg font-medium pb-2">
        {RLT.roleTypes.map((roleType, index) => (
          <div key={index} className="w-1/3 px-1 mb-2">
            <Pill className="mr-0" selected={selected(roleType)} onClick={() => onSelectRole(roleType)}>
              {roleType.identifier}
            </Pill>
          </div>
        ))}
      </div>
    </div>
    <div className="flex-none rounded-md text-sm font-medium pb-2">
      Users
      <div className="flex flex-wrap rounded-md text-lg font-medium pb-2">
        {rawUsers.filter(_ => _.roleType === currentUser.roleType.identifier).map((user, index) => (
          <div key={index} className="w-1/3 px-1 mb-2">
            <Pill className="mr-0" selected={selectedUser(user)} onClick={() => onSelectUser(user)}>
              <div className="truncate">
                {user.firstName}&nbsp;{user.lastName}
              </div>
            </Pill>
          </div>
        ))}
      </div>
    </div>
  </>;
}
